import React from 'react';
import { useLabels } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { SCROLL_TO_TOP_TOPIC } from '../global-constants';

const ScrollToTop = () => {
	const labels = useLabels();
	const scrollLabel = labels.get('SCROLL_TO_TOP');
	const pubsub = isBrowser && window?.DDC?.pubsub;

	const handleScroll = () => {
		setTimeout(() => {
			window.scrollTo({ top: -50, behavior: 'smooth' });
			if (pubsub) {
				pubsub.publish(SCROLL_TO_TOP_TOPIC);
			}
		}, 10);
	};

	return (
		<p className="h6 text-content-container flex-shrink-0">
			{/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
			<a href="#" onClick={handleScroll}>
				{scrollLabel}
			</a>
		</p>
	);
};

export default ScrollToTop;
